var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollege(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 72,
    viewBox: "0 0 79 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0199 31.5996L57.42 31.9997L65.4999 22.56L39.3399 0.15999L13.0999 22.56L21.1802 31.9997L21.5803 31.5996V33.6794L0.780273 33.68V71.84H78.2203V33.68H57.0203L57.0199 31.5996ZM21.0199 23.1197L39.3399 7.51973L57.5799 23.1197L56.7797 23.9998L39.3397 9.11976L21.8197 24.0798L21.0199 23.1197ZM6.3799 66.2397V39.2797H21.5799V66.2397H6.3799ZM42.6199 66.2397H36.0602V60.6399H42.6205L42.6199 66.2397ZM48.2198 66.2397V55.04H30.4598V66.2397H27.26V26.7997L39.3399 16.4794L51.4202 26.7997V66.2397H48.2198ZM72.6198 39.2797V66.2397H57.0198V39.2797H72.6198Z",
    fill: "#1888A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3799 46.4796H48.2199V52.0794H30.3799V46.4796Z",
    fill: "#1888A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 42.1596H13.0999V50.7996H7.5V42.1596Z",
    fill: "#1888A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7002 42.1596H20.3001V50.7996H14.7002V42.1596Z",
    fill: "#1888A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 53.9996H13.0999V62.6396H7.5V53.9996Z",
    fill: "#1888A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7002 53.9996H20.3001V62.6396H14.7002V53.9996Z",
    fill: "#1888A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.54 42.1596H64.1399V50.7996H58.54V42.1596Z",
    fill: "#1888A0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7402 42.1596H71.3401V50.7996H65.7402V42.1596Z",
    fill: "#1888A0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.54 53.9996H64.1399V62.6396H58.54V53.9996Z",
    fill: "#1888A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7402 53.9996H71.3401V62.6396H65.7402V53.9996Z",
    fill: "#1888A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5001 42.7196C41.2826 42.7196 42.9917 42.012 44.2518 40.7514C45.5124 39.4914 46.22 37.7822 46.22 35.9997C46.22 34.2173 45.5124 32.5082 44.2518 31.248C42.9918 29.9874 41.2826 29.2799 39.5001 29.2799C37.7177 29.2799 36.0086 29.9875 34.7484 31.248C33.4878 32.5081 32.7803 34.2173 32.7803 35.9997C32.7803 37.7822 33.4879 39.4913 34.7484 40.7514C36.0085 42.012 37.7177 42.7196 39.5001 42.7196ZM39.5001 34.9596C39.96 34.9607 40.3729 35.2431 40.5403 35.6716C40.7077 36.1002 40.5967 36.5874 40.2596 36.9004C39.922 37.2135 39.4281 37.2888 39.013 37.0896C38.5983 36.891 38.3472 36.4585 38.3801 35.9998C38.3801 35.3815 38.8818 34.8798 39.5001 34.8798L39.5001 34.9596Z",
    fill: "#1888A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollege);
export default __webpack_public_path__ + "static/media/college.b4a046585fe46be4b008fb02205dc99f.svg";
export { ForwardRef as ReactComponent };